module.exports = __webpack_public_path__ + "static/media/download.98752b52.svg";